import { render, staticRenderFns } from "./LoaderPayment.vue?vue&type=template&id=37ae3e0c&scoped=true&"
import script from "./LoaderPayment.vue?vue&type=script&lang=js&"
export * from "./LoaderPayment.vue?vue&type=script&lang=js&"
import style0 from "./LoaderPayment.vue?vue&type=style&index=0&id=37ae3e0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ae3e0c",
  null
  
)

export default component.exports